import clsx from 'clsx';

import type { CheckboxProps } from '@/components/base/Checkbox';
// Components
import Checkbox from '@/components/base/Checkbox';
import Label from '@/components/base/Label';
import Loader from '@/components/base/Loader';

type ButtonCheckboxProps = CheckboxProps & {
    count: number;
};

const ButtonCheckbox = ({ children, checked, count, ...restProps }: ButtonCheckboxProps) => {
    return (
        <Label
            fontType="checkbox"
            className="flex cursor-pointer items-center space-x-3 whitespace-nowrap rounded-md bg-white px-5 py-4 dark:bg-icoDarkMode-deepBlack">
            <Checkbox checked={checked} {...restProps} />
            <span className="flex items-center space-x-0.5">
                <span className="first-letter:uppercase">{children}</span>
                <span
                    className={clsx('flex items-center', {
                        'text-icoBlue': checked,
                        'text-icoGray-500 dark:text-icoDarkMode-wolf': !checked
                    })}>
                    ({typeof count === 'undefined' ? <Loader className="h-3.5 w-3.5" /> : count})
                </span>
            </span>
        </Label>
    );
};

export default ButtonCheckbox;
